module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAPlJREFUWAntVsENwjAMtCNmYAWmgIL4lTeswJ89+oc5kPqDpvwYgQ1YgG+MqVSpStLISEhUlfNpfTk352stF0CXOqAOqAMjcQAldVh7PTBxI+EGHMQyy1ZFgHvAxIujIRLkgPAExFuU0AcSLYAo5+3fCGnOYRFc2anvzBhe1xWwkF1sz8eMD/wrViG+84NxRNQ1H/XkXGGry9GvJBVzzgsR7ylOuycWYtCcidyjTZRcEc2MgKYSrlgIIdhsuf62ffdAoO0reRMBZzBdMxgh4o8VHM2b2RGYmgA4h4elaImEcMeUzQR2tBU9tUvi34BuqPfqgDqgDozegTdcGDmjq2BONQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/icon_hengju.png
// module id = F6/l
// module chunks = 1